import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import {withApollo} from 'react-apollo'
import gql from 'graphql-tag'

const BaseMaterialsFetch = gql`
  query BaseMaterialsQuery($q: String) {
    base_materials(q: $q) {
      id
      designation_name
    }
  }
`

class BaseMaterialAsyncSelect extends Component {
  constructor() {
    super()
    this.getBaseMaterials = this.getBaseMaterials.bind(this)
  }

  static propTypes = {
    client: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.object
  }

  fetchBaseMaterials(q) {
    return this.props.client.query({
      query: BaseMaterialsFetch,
      fetchPolicy: 'network-only',
      variables: {q: q}
    }).then(({data}) => {
      return {options: data.base_materials}
    })
  }

  getBaseMaterials(input) {
    if ((input && input.length < 2) || !input) {
      return Promise.resolve({options: []})
    }

    return this.fetchBaseMaterials(input)
  }

  render() {
    const AsyncComponent = Select.Async
    return (
      <AsyncComponent
        multi={false}
        value={this.props.value || {}}
        onChange={this.props.onChange}
        valueKey="id"
        labelKey="designation_name"
        loadOptions={this.getBaseMaterials}
        backspaceRemoves={true}/>
    )
  }
}

export default withApollo(BaseMaterialAsyncSelect)



// WEBPACK FOOTER //
// ./src/components/Welds/helpers/BaseMaterialAsyncSelect.js